import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getCustomers, getCustomersMeta } from "../../redux/customers";
import { HubTableTemplate } from "../../components";
import { useDeleteCustomerById } from "../../hooks";
import { WarningDeleteDialog } from "../../dialogs";

import CompaniesContextMenu from "./CompaniesContextMenu";
import { items, keys } from "./helper";

const TableContextMenu = ({ item, setDeletingId }) => (
  <CompaniesContextMenu
    id={item?.id}
    active={item?.active}
    setDeletingId={setDeletingId}
  />
);

const CompaniesTableComponent = ({ customers = [], meta }) => {
  const navigate = useNavigate();

  const [deletingId, setDeletingId] = useState(false);
  const { mutate: deleteCustomerById, isSuccess } = useDeleteCustomerById();

  const handleClose = () => setDeletingId(false);
  const handleSubmit = () => deletingId && deleteCustomerById(deletingId);

  useEffect(() => {
    isSuccess && handleClose();
  }, [isSuccess]);

  const onRowClick = (e, item) => {
    if (item?.id) {
      e.preventDefault();
      e.stopPropagation();
      navigate(`/customers/${item?.id}`);
    }
  };

  const ContextMenu = ({ item }) => (
    <TableContextMenu item={item} setDeletingId={setDeletingId} />
  );

  const headerProps = { items, includeEnd: true, includeChevron: true };
  const bodyProps = {
    items: customers,
    keys,
    ContextMenu,
    onRowClick,
    includeChevron: true,
  };
  const props = { headerProps, bodyProps, meta };

  return (
    <>
      <HubTableTemplate id="CompaniesTable" {...props} />
      <WarningDeleteDialog
        isOpen={!!deletingId}
        onClose={handleClose}
        onSubmit={handleSubmit}
        title="You are about to delete this customer!"
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  customers: getCustomers(state),
  meta: getCustomersMeta(state),
});

export const CompaniesTable = connect(mapStateToProps)(CompaniesTableComponent);
export default CompaniesTable;
